@use '@design/design-tokens/typography/typography' as *;
@use '@design/design-tokens/border-radius/border-radius' as *;
@use '@design/components/custom-scroll/custom-scroll' as *;

.styledModal {
  [data-modal-container] {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    width: 95%;
    max-width: 800px;
    height: 100%;
    max-height: 604px;
    padding-bottom: 0;
  }

  [data-modal-text-container] {
    margin: 18px 0 0;
  }

  [data-modal-header] {
    padding: 6px 6px 24px 20px;
  }
}

.container {
  display: flex;
  gap: 20px;
  flex: 1;
  flex-direction: column;
  min-height: 0;
  padding: 12px 20px;

  > [data-button-group] {
    @include border-radius-r2;
  }
}

.nodesWrapper {
  @include custom-scroll-minimal;

  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 8px;
  overflow-y: auto;
  min-height: 0;

  > [data-testid='tree-node'] {
    margin-left: -20px;
  }

  mark {
    color: var(--text-primary);
    background-color: transparent;
  }
}

.search {
  [data-input-wrapper] {
    @include border-radius-r2;

    border: 1px solid var(--border-default);
    padding: 8px 12px;
    width: 100%;
    background-color: transparent;
  }
}

.footerButtons {
  position: relative;
  z-index: 1;
  display: flex;
  flex: 0 0 auto;
  justify-content: space-between;
  background: var(--background-soft);
  padding: 24px 20px;

  &::before {
    position: absolute;
    right: 0;
    bottom: 100%;
    left: 0;
    height: 24px;
    background: linear-gradient(
      to bottom,
      transparent,
      var(--background-soft)
    );
    content: '';
    pointer-events: none;
  }
}

.confirmationButtons {
  display: flex;
  gap: 8px;
  margin-left: auto;
}

.clearButton {
  @include typography-v2-body-sm;

  color: var(--text-soft);
  cursor: pointer;

  &:hover {
    color: var(--text-default);
  }
}

.noResultsLabel {
  color: var(--text-soft);
}
